import API from "./api";

// ✅ GET
export const getBranches = () => API.get("/Branch");

// ✅ CREATE
export const addBranch = (branch) =>
    API.post("/Branch", branch);

// ✅ UPDATE
export const updateBranch = (id, branch) =>
    API.put(`/Branch/${id}`, branch);

// ✅ SOFT DELETE (DEACTIVATE)
export const deactivateBranch = (id) =>
    API.put(`/Branch/deactivate/${id}`);

// ✅ PERMANENT DELETE
export const deleteBranch = (id) =>
    API.delete(`/Branch/${id}`);